import styled, { css } from "styled-components"
import Breakpoints from "../breakpoints"
import SmartLink from "../smart-link"
import { FontFamilySmartScreen, mobileTextStyles } from "../typography.styles"

export const SidebarContainer = styled.nav<{ isVisible: boolean }>`
  overflow-y: scroll;

  visibility: ${(props) => (props.isVisible ? "visible" : "hidden")};

  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  background: var(--white);
  transition: all 0.5s ease-out;
  transform: translateX(${(props) => (props.isVisible ? "0" : "100vw")});
  color: var(--body-text-grey);
  padding: 24px 16px;

  box-sizing: border-box;

  @media (min-width: ${Breakpoints.md}) {
    width: 80vw;
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.4);
    left: unset;
  }

  @media (min-width: ${Breakpoints.lgPlus}) {
    display: none;
  }
`

const SubcategoryHeadingStyle = css`
  ${mobileTextStyles.MobileSubHeading}
  text-align: left;
  margin-bottom: 24px;

  text-decoration: none;
`

export const SubcategoryHeadingLink = styled(SmartLink)`
  &,
  :link,
  :visited,
  :active {
    color: var(--deep-cyan);
  }

  ${SubcategoryHeadingStyle}
  margin-bottom: 12px;
  font-size: 16px;
  letter-spacing: 0.08em;
  display: flex;
  align-items: center;
  text-transform: none;

  & img {
    margin-right: 12px;
    height: 15px;
    width: 15px;
    object-fit: contain;
  }
`

export const SubcategoryHeadingTitle = styled.h4`
  ${SubcategoryHeadingStyle}
  color: var(--deep-cyan);
  margin-bottom: 12px;
  font-size: 16px;
  letter-spacing: 0.08em;
  display: flex;
  align-items: center;
  text-transform: none;
`
export const SectionHeading = styled.h3`
  ${FontFamilySmartScreen}
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 140%;
  /* identical to box height, or 34px */
  text-align: left;

  letter-spacing: 0.08em;
  text-transform: uppercase;

  /* new/burnt_orange */

  color: var(--deep-cyan);
  padding-bottom: 20px;
`

export const PanelLink = styled(SmartLink)`
  ${mobileTextStyles.MobileBodyRegular}
  font-size: 16px;
  color: var(--body-text-grey);

  display: inline-flex;
  align-items: center;
  & img {
    margin-right: 12px;
    height: 15px;
    width: 15px;
    transform: translateY(-1px); /* align nicer to text */
  }

  align-self: flex-start;
  text-decoration: none;
  line-height: 150%;
  :visited {
    color: unset;
  }
`

export const ShowMoreLink = styled(SubcategoryHeadingLink)`
  margin-bottom: 24px;

  :last-of-type {
    margin-bottom: unset;
  }
`

export const CloseButton = styled.button`
  position: absolute;
  right: 24px;
  top: 4px;
  width: 32px;
  height: 32px;

  background-color: rgba(0, 0, 0, 0);
  outline: none;
  border: none;
  cursor: pointer;

  ::before,
  ::after {
    position: absolute;
    left: 15px;
    content: " ";
    height: 28px;
    width: 2px;
    background-color: var(--slate);
  }
  ::before {
    transform: rotate(45deg);
  }
  ::after {
    transform: rotate(-45deg);
  }
`

export const SidebarLinkGroupWrapper = styled.div<{
  columns: { sm: number; md: number }
  $gap: number
}>`
  display: inline-grid;
  grid-gap: ${({ $gap }) => ($gap ? `${$gap}px` : `12px`)};
  overflow: hidden;

  grid-template-columns: repeat(${(props) => props.columns.sm}, 1fr);
  @media (min-width: 750px) {
    display: inline-grid;
    grid-template-columns: repeat(${(props) => props.columns.md}, auto);
    grid-gap: ${({ $gap }) => ($gap ? `${$gap}px` : `12px`)} 32px;
  }
`

export const SidebarCategoryWrapper = styled.div`
  margin-bottom: 48px;

  :last-of-type {
    margin-bottom: 32px;
  }
`

export const SidebarCategoryOuterWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px 32px;

  @media (min-width: 750px) {
    display: inline-flex;
    flex-wrap: wrap;
    width: 100%;
  }
`
